import styled, { css } from 'styled-components';
import { Tags } from './Tags.style.js';
import { Bullet } from './Bullets.style.js';
import { Paragraph } from './Paragraph.style.js';
import { IncludedProducts } from './IncludedProducts.style.js';
import { Ratings } from './Ratings.style.js';
import mq from '../../../utils/mediaQueries.js';
import { isDefaultTheme } from '../../../utils/theming.js';

// @ts-nocheck
var CardContent = styled.div.withConfig({
  displayName: "CardContentstyle__CardContent",
  componentId: "sc-bmkf8o-0"
})(["display:flex;flex-direction:column;align-self:stretch;height:100%;", " ", "{margin-bottom:var(--space-200);}.uikit-card-content-title:has(+ *){margin-bottom:var(--space-100);}", "{margin:var(--space-200) 0 12px;}", "{", "}", "{", "}.uikit-article-card-button::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;z-index:2;}", "{", " ", "}", ""], function (_ref) {
  var $variant = _ref.$variant,
    $isPortraitCard = _ref.$isPortraitCard,
    $footerAtBottom = _ref.$footerAtBottom;
  return $variant !== 'article' && css(["padding-bottom:var(--space-400);", ""], !$isPortraitCard && !$footerAtBottom && isDefaultTheme(css(["", ""], mq.m(css(["padding-bottom:0;"])))));
}, Tags, Ratings, Bullet, function (_ref2) {
  var $isPortraitCard = _ref2.$isPortraitCard;
  return $isPortraitCard && css(["flex-basis:100%;"]);
}, Paragraph, function (_ref3) {
  var $variant = _ref3.$variant;
  return $variant !== 'article' && css(["overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;"], $variant === 'room' ? 3 : 2);
}, IncludedProducts, mq.sMax(css(["display:none;"])), function (_ref4) {
  var $imagePosition = _ref4.$imagePosition,
    $columnSpan = _ref4.$columnSpan;
  return $imagePosition === 'top' && $columnSpan < 6 && css(["display:none;"]);
}, function (_ref5) {
  var $variant = _ref5.$variant;
  return $variant === 'room' && css(["display:flex;flex-direction:column;"]);
});
var CardContentUpper = styled.div.withConfig({
  displayName: "CardContentstyle__CardContentUpper",
  componentId: "sc-bmkf8o-1"
})(["&:has(+ *:not(:empty)){margin-bottom:var(--space-200);}", " &:empty{display:none;}", ""], mq.s(css(["column-gap:var(--space-300);"])), function (_ref6) {
  var $variant = _ref6.$variant;
  return $variant === 'room' && css(["flex-shrink:0;"]);
});
var CardContentLower = styled.div.withConfig({
  displayName: "CardContentstyle__CardContentLower",
  componentId: "sc-bmkf8o-2"
})(["display:flex;flex-direction:column;gap:var(--space-200);&:empty{display:none;}", " ", " ", " .uikit-card-promotion-badge{", "}"], mq.s(css(["gap:var(--space-300);"])), function (_ref7) {
  var $variant = _ref7.$variant,
    $isPortraitCard = _ref7.$isPortraitCard;
  return $variant === 'article' && css(["gap:var(--space-300);flex-grow:1;", " ", ""], mq.s(css(["gap:var(--space-400);"])), $isPortraitCard && isDefaultTheme(css(["", ""], mq.s(css([".uikit-article-card-button{margin-top:auto;}"])))));
}, function (_ref8) {
  var $variant = _ref8.$variant;
  return $variant === 'room' && css(["flex-grow:1;"]);
}, mq.s(css(["margin-top:var(--space-300);"])));

export { CardContent, CardContentLower, CardContentUpper };
//# sourceMappingURL=CardContent.style.js.map
